import styled from 'styled-components';

const defaultSize = 1.3;

export const Pill = styled.span`
    line-height: initial;
    border-radius: ${({ size = defaultSize }) => `${size}rem`};
    font-size: ${({ fontSize }) => (fontSize ? `${fontSize}rem` : 'inherit')};
    background: ${({ theme }) => theme.colors.brand.P3};
    color: ${({ theme }) => theme.colors.fixed.white} !important;
    width: auto;
    height: ${({ size = defaultSize }) => `${size}rem`};
    line-height: ${({ size = defaultSize }) => `${size}rem`};
    padding: 2px 10px;
`;
